import { showError, showHttpError, showSuccess } from '@calendly/alert'
import { httpRequest } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'

import { redirectTo, openAndFocusTo } from 'actions/core/navigation'

import { STATE_TESTED } from './constants'
import { setCurrentSsoStep, setSamlSsoSettings, setTestSamlSettings } from './slice'

export const toggleEnforcement = () => async (dispatch) => {
  const [success, response] = await httpRequest({
    url: '/api/organization/identity_provider/toggle',
    method: 'POST'
  })

  if (!success) {
    dispatch(showHttpError(response))
    return
  }

  dispatch(showSuccess(I18n.t('publisher.flash.settings_saved')))
  dispatch(redirectTo('/app/login'))
}

export const testSamlConnection = (result, nextStep) => (dispatch) => {
  if (!result || result.source !== 'saml_connection_test') return

  if (result.state === 'success') {
    dispatch(showSuccess(result.message))
    dispatch(setTestSamlSettings({ step: nextStep }))
  } else {
    dispatch(showError(result.message))
  }
}

export const testSsoConnection = (result) => (dispatch) => {
  if (!result || result.source !== 'saml_connection_test') return


  if (result.state !== 'success') {
    dispatch(showError(result.message))
    return
  }

  dispatch(showSuccess(result.message))
  dispatch(setSamlSsoSettings({ state: STATE_TESTED }))
  dispatch(setCurrentSsoStep(STATE_TESTED))
}

export const openInNewWindowAuthorizeUrl = (path) => (
  async (dispatch) => {
    const [success, data] = await httpRequest({
      method: 'POST',
      url: path
    })

    if (!success) {
      dispatch(showHttpError(data))
      return
    }

    dispatch(openAndFocusTo(data.url))
  }
)
